export function fetchAllDepartments() {
  return window.axios
    .get("/identity/departments/all")
    .then((response) => response.data);
}
